<template >


  <div class="wrapper">

      <header class="main-header">
          <!-- Logo -->
          <a href="index2.html" class="logo">
              <!-- mini logo for sidebar mini 50x50 pixels -->
              <span class="logo-mini"><b>T</b>C</span>
              <!-- logo for regular state and mobile devices -->
              <span class="logo-lg"><b>Tribunal</b>C</span>
          </a>
          <!-- Header Navbar: style can be found in header.less -->
          <nav class="navbar navbar-static-top">
              <!-- Sidebar toggle button-->
              <a href="#" class="sidebar-toggle" data-toggle="offcanvas" role="button">
                  <span class="sr-only">Toggle navigation</span>
              </a>

              <div class="navbar-custom-menu">
                  <ul class="nav navbar-nav">

                      <!-- User Account: style can be found in dropdown.less
                      <li class="dropdown user user-menu">
                          <a href="#" class="dropdown-toggle" data-toggle="dropdown">
                              <img src="#" class="user-image" alt="User Image">
                              <span class="hidden-xs">Tribunal</span>
                          </a>
                          <ul class="dropdown-menu">
                              <li class="user-header">
                                  <img src="#" class="img-circle" alt="User Image">

                                  <p>
                                      Tribunal
                                      <small></small>
                                  </p>
                              </li>
                              <!-- Menu Body
                              <li class="user-body">
                                  <div class="row">
                                      <div class="col-xs-4 text-center">
                                          <a href="#">Followers</a>
                                      </div>
                                      <div class="col-xs-4 text-center">
                                          <a href="#">Sales</a>
                                      </div>
                                      <div class="col-xs-4 text-center">
                                          <a href="#">Friends</a>
                                      </div>
                                  </div>
                                  <!-- /.row
                              </li> -->
                              <!-- Menu Footer
                              <li class="user-footer">
                                  <a href="<?=base_url()?>admin/login/logout" class="btn btn-default btn-flat">Salir</a>
                                  <!--
                                  <div class="pull-left">
                                      <a href="#" class="btn btn-default btn-flat">Profile</a>
                                  </div>
                                  <div class="pull-right">
                                      <a href="#" class="btn btn-default btn-flat">Sign out</a>
                                  </div>
                              </li>

                            </ul>
                        </li>
                      -->

                      <li><a href="/aplicaciones/logout">Salir Sessión</a></li>
                  </ul>
              </div>
          </nav>
      </header>
      <!-- Left side column. contains the logo and sidebar -->
      <aside class="main-sidebar">
          <!-- sidebar: style can be found in sidebar.less -->
          <section class="sidebar">
              <!-- Sidebar user panel -->
              <div class="user-panel">
                  <div class="pull-left image">
                      <img src="http://www.tc.gob.pe/tc/public/assets/images/tc_logo_superior.png" class="img-circle" alt="User Image">
                  </div>
                  <div class="pull-left info">
                      <p>Tribunal</p>
                      <a href="#"><i class="fa fa-circle text-success"></i> Online</a>
                  </div>
              </div>
              <!-- search form -->

              <!-- /.search form -->
              <!-- sidebar menu: : style can be found in sidebar.less -->

              <Navigation/>

          </section>
          <!-- /.sidebar -->
      </aside>

      <!-- Content Wrapper. Contains page content -->
      <div class="content-wrapper">


        <router-view></router-view>




        </div>
    <!-- /.content-wrapper -->

    <!-- /.content-wrapper -->
    <footer class="main-footer">
        Potenciado por <a href="http://somossistemas.org/">Somos sistemas</a> 2017
    </footer>
  </div>
</template>

<script>

  import Navigation from '@/components/shared/Navigation';

  export default {
    components : { Navigation},
    name: 'App',
    data () {
      return {
        msg: '',
        year : new Date().getFullYear(),
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/App.vue